import { faCode } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@repo/videa-components/src/ui/button';
import { useSetAtom } from 'jotai';

import { insPagesAtom } from '@/modules/claims/freeClaims/state';
import type {
  GetClaimSummaryResponse,
  TTreatmentResponse,
} from '@/modules/claims/freeClaims/insuranceExport/types';

import { Configurations } from './configureSection/Configurations';
import { SubmissionChecklist } from './configureSection/SubmissionChecklist';

type ClaimCustomizationSidebarProps = {
  defaultTreatments: TTreatmentResponse[];
  onSelectTreatments: (txIds: string[]) => void;
  claimSummary?: GetClaimSummaryResponse;
};

export const ClaimCustomizationSidebar = ({
  defaultTreatments,
  onSelectTreatments,
  claimSummary,
}: ClaimCustomizationSidebarProps) => {
  const setInsPage = useSetAtom(insPagesAtom);

  return (
    <div className="vai-bg-white vai-flex vai-flex-col vai-gap-10 vai-w-[504px] vai-h-full vai-overflow-y-auto vai-border-l vai-px-10 vai-py-6">
      <SubmissionChecklist />
      <Configurations
        defaultTreatments={defaultTreatments}
        onSelectTreatments={onSelectTreatments}
        claimSummary={claimSummary}
      />
      {/* Dev Tool */}
      {['development', 'local', 'test'].includes(
        process.env.VITE_ENV ?? '',
      ) && (
          <div className="vai-flex vai-justify-end vai-self-start">
            <Button onClick={() => setInsPage('dev-tool')} variant="ghost">
              <FontAwesomeIcon icon={faCode} />
              Dev Tool
            </Button>
          </div>
        )}
    </div>
  );
};
